// ------------------------------------
// Constants
// ------------------------------------
export const USER_LOGIN = 'USER_LOGIN'
export const SET_PRICE_TIER = 'SET_PRICE_TIER'
export const SET_CURRENCY = 'SET_CURRENCY'
export const SET_APP_VERSION = 'SET_APP_VERSION'
export const USER_LOGOUT = 'USER_LOGOUT'

// ------------------------------------
// Actions
// ------------------------------------

export const userLogin = ({ user, currency}) => ({
    type: USER_LOGIN,
    user,
    currency
});

export const userLogout = () => ({
    type: USER_LOGOUT
});

export const setPriceTier = ({ price_tier, price_tier_multiplier, price_tier_multiplier_dragonfly}) => ({
    type: SET_PRICE_TIER,
    price_tier,
    price_tier_multiplier,
    price_tier_multiplier_dragonfly
});

export const setCurrency = ({ currency }) => ({
    type: SET_CURRENCY,
    currency
});

export const setAppVersion = ({ app_version }) => ({
    type: SET_APP_VERSION,
    app_version
});

// ------------------------------------
// Reducer
// ------------------------------------

const initialState = {
    user: null,
    currency: null,
    price_tier: 0,
    price_tier_multiplier: 1,
    price_tier_multiplier_dragonfly: 1,
    app_version: "1.0.0"
};

const user = (state = initialState, action) => {
    switch (action.type) {
        case USER_LOGIN:
            return {
                ...state,
                user: action.user,
                currency: action.currency
            }
        case SET_PRICE_TIER:
            return {
                ...state,
                price_tier: action.price_tier,
                price_tier_multiplier: action.price_tier_multiplier,
                price_tier_multiplier_dragonfly: action.price_tier_multiplier_dragonfly
            }
        case SET_CURRENCY:
            return {
                ...state,
                currency: action.currency
            }
        case SET_APP_VERSION:
            return {
                ...state,
                app_version: action.app_version
            }
        case USER_LOGOUT:
            return {
                ...state,
                user: initialState.user,
                currency: initialState.currency,
                price_tier: initialState.price_tier,
                price_tier_multiplier: initialState.price_tier_multiplier,
                price_tier_multiplier_dragonfly: initialState.price_tier_multiplier_dragonfly
            }
        default:
            return state
    }
}

export default user



// WEBPACK FOOTER //
// ./../../htdocs/neutrik-opticalcon_fe/src/modules/user.js